module.exports = __webpack_public_path__ + "static/img/company.f57a3600.png";